import i18next from 'i18next'
import {InvoiceStatus} from '@/stores/invoices/models/InvoiceStatus'
export const invoiceTabs = () => [
    {
        title: i18next.t('Invoices.all'),
        key: InvoiceStatus.all
    },

    {
        title: i18next.t('Invoices.issued'),
        key: InvoiceStatus.issued
    },
    {
        title: i18next.t('Invoices.paid'),
        key: InvoiceStatus.paid
    }
]
